import React, { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Button, LinkButton } from '@eika/button';
import { InfoCard } from '@eika/card';
import { IconTypes } from '@eika/icon';
import { Loader } from '@eika/loader';
import { Modal } from '@eika/modal';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useGeoOmraade } from '../../hooks/useGeoOmraade';
import { useSaveSoeknad } from '../../hooks/useSoeknadMedlaantaker';
import { useTranslation } from '../../translations';
import { BOLIGLAAN_LAANEFORMAAL_URL } from '../modal/userMessageDeleteSoeknad';
import { PAGE_BOLIGSALG_URL } from '../page/pageUrl';

const Geolokasjon: FC = () => {
    const { state } = useLocation();
    const soeknad = state.newSoeknad;
    const { geolokasjon, button } = useTranslation();
    const navigate = useNavigate();
    const { data: geoOmraade } = useGeoOmraade();

    const [showModal, setShowModal] = React.useState(false);

    const { mutate: saveSoeknad, isPending: savingSoeknad } = useSaveSoeknad(() => {
        navigate(PAGE_BOLIGSALG_URL);
    });

    return (
        <div>
            <Modal
                title={geolokasjon.modalTitle}
                description={geolokasjon.modalsubtitle}
                open={showModal}
                setOpen={() => setShowModal(true)}
                onClose={() => setShowModal(false)}
                size="large"
                appNamespace="kreditt.boliglaansoeknad.finansieringsbevis-view"
                contentShouldStretch
            >
                <ul>
                    {geoOmraade?.map((postnummer) => (
                        <li key={postnummer.value}>
                            {geolokasjon.modalPoststed.replace('{postnummer}', postnummer.value)}
                        </li>
                    ))}
                </ul>
                <div className="center-button button-bottom-large">
                    <LinkButton onClick={() => setShowModal(false)} data-track-id="avslutt-sak-success">
                        {button.lukk}
                    </LinkButton>
                </div>
            </Modal>
            <div className="sgw-layout margin-top-extra-large">
                <InfoCard
                    asHeader
                    className="sgw-layout-item sgw-layout-item__full-width"
                    img={<RichIcon type={RichIconTypes.BAEREKRAFT_KORTREIST} />}
                >
                    <InfoCard.TitleH1>{geolokasjon.title}</InfoCard.TitleH1>
                </InfoCard>
            </div>
            <div className="sgw-layout medium-centered-container">
                <div className="sgw-layout-item">
                    <div className="row row-gap-large">
                        <h2>{geolokasjon.subTitle.replace('{fornavn}', `${soeknad.laantaker.fornavn}`)}</h2>
                        <span className="typography-ingress__light">{geolokasjon.infoGeolokasjon.hovedinfo}</span>
                        <span>{geolokasjon.infoGeolokasjon.subinfo}</span>
                        <LinkButton onClick={() => setShowModal(!showModal)} icon={IconTypes.KART_24}>
                            {geolokasjon.linkInfo}
                        </LinkButton>
                    </div>
                    <div className="column justify-content-center margin-top-extra-large">
                        <div className="row row-gap align-items">
                            {savingSoeknad ? (
                                <Loader />
                            ) : (
                                <Button onClick={() => saveSoeknad(state.newSoeknad)}>{button.fortsettSoeknad}</Button>
                            )}
                            <LinkButton onClick={() => window.location.replace(BOLIGLAAN_LAANEFORMAAL_URL)}>
                                {button.avsluttSoeknad}
                            </LinkButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Geolokasjon;
